<form *ngIf="fields && form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'params.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'params.edit_title' | translate}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/params" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.param_group.nullable}">{{ fields.param_group.keyName }}</span>
          <p-autoComplete [suggestions]="filterParam"
                          formControlName="param_group"
                          (completeMethod)="filterParamSingle($event)"
                          (onSelect)="selectParamSingle($event)"
                          placeholder="{{ fields.param_group.keyName }}"
                          [minLength]="2">
            <ng-template let-param pTemplate="item">
              <div class="ui-helper-clearfix">
                <div>{{param}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.param_group"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.param_code.nullable}">{{ fields.param_code.keyName }}</span>
          <input type="text" pInputText class="fieldInput CustomInput" formControlName="param_code"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.param_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.param_order.nullable}">{{ fields.param_order.keyName }}</span>
          <input type="number" pInputText class="fieldInput CustomInput" formControlName="param_order"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && form.controls.param_order.errors?.integerNotNegative">Solo valori interi positivi</span>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.param_order"></app-validation-msg>

        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</span>
          <input type="text" pInputText class="fieldInput CustomInput" formControlName="description"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.description"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.division_id.nullable}">{{ fields.division_id.keyName }}</span>
          <p-dropdown [options]="listDivision" [filter]="true" formControlName="division_id">
            <ng-template let-division pTemplate="item">
              <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                <div style="font-size:14px;float:left;margin-top:4px">{{ division.label }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.division_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.param_functional_code.nullable}">{{ fields.param_functional_code.keyName }}</span>
          <p-dropdown [disabled]="disabledFunctionalCode" class="CustomInput" [options]="listFunctionCode" formControlName="param_functional_code"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.param_functional_code"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.param_key.nullable}">{{ fields.param_key.keyName }}</span>
          <input type="text" #paramKey data-testid="paramKey" pInputText class="fieldInput CustomInput" formControlName="param_key"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.param_key"></app-validation-msg>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <hr>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-4">
          <button pButton type="button" icon="fa fa-plus-circle" label="{{'channel.add_title' | translate}}" iconPos="left" (click)="addOchannel()" class="k-generic-btn" ></button>
        </div>
      </div>
      <div formArrayName="ochannels">
        <div class="ui-g ui-fluid" *ngFor="let ochannel of ochannels.controls; let i=index" [formGroupName]="i">
          <p-panel class="ui-g-12">
            <p-header>
              <div class="ui-helper-clearfix">
                <span class="ui-panel-title"></span>
                <button pButton type="button" icon="fa fa-times" (click)="deleteOchannel(i, ochannel)" class="ui-button-danger btnDelete"></button>
              </div>
            </p-header>
            <div class="ui-g-12  ui-fluid">
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsChannels.ochannel_type_pid.nullable}">{{ fieldsChannels.ochannel_type_pid.keyName }}</span>
                <p-dropdown class="CustomInput" [options]="listParamOchannel" formControlName="ochannel_type_pid" ></p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel" [validation]="fieldsChannels.ochannel_type_pid"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsChannels.code.nullable}">{{ fieldsChannels.code.keyName }}</span>
                <input type="text" pInputText class="fieldInput CustomInput" formControlName="code"/>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel" [validation]="fieldsChannels.code"></app-validation-msg>
              </div>
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !fieldsChannels.description.nullable}">{{ fieldsChannels.description.keyName }}</span>
                <input type="text" pInputText class="fieldInput CustomInput" formControlName="description"/>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="ochannel" [validation]="fieldsChannels.description"></app-validation-msg>
              </div>
            </div>
            <p-footer class="clearfix">&nbsp;</p-footer>
          </p-panel>
        </div>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-params/form-param-loyalty/form-param-loyalty.component.html